import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../apiConfig";
import { useNavigate } from "react-router-dom";
import SidebarMenu from '../components/SidebarMenu';

const Lideres = () => {
  const [lideres, setLideres] = useState([]);
  const [niveles, setNiveles] = useState([]);
  const [nivelSeleccionado, setNivelSeleccionado] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);  // Define cuántos líderes mostrar por página
  const [searchTerm, setSearchTerm] = useState(""); //FILTRO POR NAME
  const navigate = useNavigate();

  useEffect(() => {
    fetchLideres();
    fetchNiveles();
  }, []);

  const fetchLideres = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/Lider/ListarLideres`);
      setLideres(response.data);
    } catch (error) {
      console.error("Error al obtener líderes:", error);
    }
  };

  const fetchNiveles = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/Lider/ListarNiveles`);
      setNiveles(response.data);
    } catch (error) {
      console.error("Error al obtener niveles:", error);
    }
  };

  // Filtrar los líderes basado en el nivel seleccionado
  const filteredLeaders = lideres
    .filter(lider => {
      return nivelSeleccionado ? lider.nivelId.toString() === nivelSeleccionado : true;
    })
    .filter(lider => {
      return searchTerm ? lider.nombre.toLowerCase().includes(searchTerm.toLowerCase()) : true;
    });


  // Calcular la paginación
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredLeaders.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredLeaders.length / rowsPerPage);

  return (
    <div className=" max-w-4xl mx-auto lg:max-w-4xl xl:max-w-6xl p-6 min-width">
      <SidebarMenu />
    <div className="bg-[#081b29] p-4 flex items-center justify-between ">
      {/* Logo y Título juntos en el lado izquierdo */}
      <div className="flex items-center space-x-4">
        <img src="/img/monytorlogoa.png" alt="Logo" className="w=32 h-32" />
        <h2 className="text-white text-3xl font-bold">Gestor de líderes</h2>
      </div>

      {/* Botón en el lado derecho */}
      <button
      className="btn text-white font-bold py-1 px-2 rounded"
      style={{ width: '180px' }}  // Ancho fijo
      onClick={() => navigate("/administradorMenu")}
    >
        Menú
      </button>
    </div>

    <div className="bg-gray-800 p-4 rounded-lg">
  <div className="flex justify-between items-center flex-wrap">
    {/* Búsqueda por nombre */}
    <div className="flex items-center space-x-2 mb-4">
      <label className="text-white">Buscar por nombre:</label>
      <input
        type="text"
        className="text-black p-2 rounded border border-gray-600"
        placeholder="Escribe el nombre"
        value={searchTerm}
        onChange={e => {
          setSearchTerm(e.target.value);
          setCurrentPage(1);  // LLEVA A LA PRIMERA PÁGINA SIN IMPORTAR DONDE
        }}
      />
    </div>

    {/* Total de líderes */}
    <h4 className="text-white px-4 py-2 rounded-lg mb-4">Total de líderes: {filteredLeaders.length}</h4>

    {/* Filtro por nivel */}
    <div className="flex items-center space-x-2 mb-4">
      <label className="text-white">Filtrar por nivel:</label>
      <select
        className="text-black p-2 rounded border border-gray-600"
        value={nivelSeleccionado}
        onChange={e => {
          setNivelSeleccionado(e.target.value);
          setCurrentPage(1);
        }}
      >
        <option value="">Todos</option>
        {niveles.map(nivel => (
          <option key={nivel.id} value={nivel.id}>{nivel.descripcion}</option>
        ))}
      </select>
    </div>
  </div>
</div>

      <div className="w-full max-w-4xl overflow-x-auto">
      <table className="w-full bg-[#081b29] text-white rounded-lg shadow-lg min-width">
  <thead>
    <tr className="bg-[#0f283a]">
      <th className="px-10 py-3 border-b border-gray-700">ID</th>
      <th className="px-10 py-3 border-b border-gray-700">Nombre</th>
      <th className="px-10 py-3 border-b border-gray-700">Usuario</th>
      <th className="px-10 py-3 border-b border-gray-700">Teléfono</th>
      <th className="px-10 py-3 border-b border-gray-700">Nivel</th>
    </tr>
  </thead>
  <tbody className="divide-y divide-gray-700">
    {currentRows.map((lider, index) => (
      <tr key={index} className="hover:bg-[#12394d] transition-colors">
        <td className="px-10 py-3 text-center">{lider.id}</td>
        <td className="px-10 py-3 text-center">{lider.nombre}</td>
        <td className="px-10 py-3 text-center">{lider.usuario}</td>
        <td className="px-10 py-3 text-center">{lider.telefono}</td>
        <td className="px-10 py-3 text-center">{lider.nivelId}</td>
      </tr>
    ))}
    {currentRows.length === 0 && (
      <tr>
        <td colSpan="5" className="text-center py-4 text-gray-400">No hay líderes registrados en este nivel.</td>
      </tr>
    )}
  </tbody>
</table>

      </div>
      <div className="flex justify-center space-x-2 mt-4">
        <button onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} disabled={currentPage === 1}>◀ Anterior</button>
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentPage(index + 1)}
            className={`px-4 py-2 rounded ${currentPage === index + 1 ? 'bg-blue-500' : 'hover:bg-[#12394d] transition'}`}
          >
            {index + 1}
          </button>
        ))}
        <button onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))} disabled={currentPage >= totalPages}>Siguiente ▶</button>
      </div>
    </div>
  );
};

export default Lideres;
